/*-----------------------------------------------------------------
- Arena Breadcrumbs trans
-----------------------------------------------------------------*/
export default {
    arena  : 'Orders',
    details: 'Order Details',
};
